import React from 'react'
import PropTypes from 'prop-types'
import { Link as GatsbyLink } from 'gatsby'
import { makeStyles } from '@material-ui/core/styles'
import Link from '@material-ui/core/Link'
import Container from '@material-ui/core/Container'
import Box from '@material-ui/core/Box'
import Typography from '@material-ui/core/Typography'
import Hidden from '@material-ui/core/Hidden'
import { RichText } from 'prismic-reactjs'

// Components
import SEO from '../../components/seo'
import ContactForm from '../../components/contactForm'
import NewsletterPrimary from '../../components/newsletterPrimary'

// Images
import Logo from './svg/image.inline.svg'

// Strings
import strings from './strings'

// Styles
const useStyles = makeStyles((theme) => ({
  newsletter: {
    margin: theme.spacing(10, 0),
    [theme.breakpoints.up('lg')]: {
      margin: theme.spacing(15, 0),
    },
  },
  title: {
    marginBottom: theme.spacing(5),
  },
  form: {
    gridArea: 'form',
    width: '540px',
    maxWidth: '100%',
    '& a': {
      color: theme.palette.primary.main,
    },
  },
  image: {
    gridArea: 'image',
    justifySelf: 'end',
    alignSelf: 'center',
    maxWidth: '100%',
  },
  container: {
    [theme.breakpoints.up('md')]: {
      display: 'grid',
      gridGap: theme.spacing(3),
      gridTemplateColumns: '540px 1fr',
      gridTemplateAreas: '"form image"',
    },
  },
  newsletterContainer: {
    [theme.breakpoints.only('xs')]: {
      paddingLeft: 0,
      paddingRight: 0,
    },
  },
}))

const ContactPage = (props) => {
  // console.log('👾 ContactPage > ', props)

  const classes = useStyles()
  const { shopifyThemePath } = props.pageContext

  const { title, content } = props.data.prismicContact.data

  return (
    <>
      <SEO title={strings.seoTitle} shopifyThemePath={shopifyThemePath} />
      <Container className={classes.container} maxWidth="lg">
        <Box className={classes.form}>
          <Typography className={classes.title} component="h1" variant="h1">
            {title}
          </Typography>

          <RichText render={content.raw} />

          <ContactForm />
        </Box>
        <Hidden smDown>
          <Logo className={classes.image} />
        </Hidden>
      </Container>
      <Container className={classes.newsletterContainer} maxWidth="lg">
        <NewsletterPrimary
          styles={classes.newsletter}
          title="Join our VIP club"
          content="Subscribe to our monthly newsletter for sneak peeks at new collections and early access to promos and flash sales!"
          helperText="Helper text goes here..."
          helper={false}
          location="contactPage"
          listId={process.env.GATSBY_KLAVIYO_GENERAL_LIST}
        />
      </Container>
    </>
  )
}

export default ContactPage

ContactPage.propTypes = {}
ContactPage.defaultProps = {}
